import { HorizontalView, VerticalView } from 'src/components/FlexViews';
import { Button } from 'src/pages/BonusGame/components/Button';
import styled from 'styled-components';
import { ReactComponent as LeftArrowIcon } from 'src/assets/icons/bonus-game/left-arrow.svg';
import { ReactComponent as RightArrowIcon } from 'src/assets/icons/bonus-game/right-arrow-2.svg';
import { ReactComponent as LockIcon } from 'src/assets/icons/lock.svg';
import { ReactComponent as CoinIcon } from 'src/assets/icons/bonus-game/coin.svg';

const TreeItemWrapper = styled(VerticalView)`
  position: relative;
  align-items: center;
`;

const ImageStyled = styled.img`
  width: 256px;
  height: auto;
`;

export const TreeItem = ({
  imgSrc,
  selected,
  handleClickNext,
  handleClickPrev,
  onApply,
  isActive,
  needToReach,
}: {
  imgSrc: string;
  selected: boolean;
  handleClickNext: () => void;
  handleClickPrev: () => void;
  isActive: boolean;
  needToReach?: string;
  coins: any;
  onApply: any;
}) => {
  return (
    <TreeItemWrapper>
      {!isActive && needToReach && <NeedToReach needToReach={needToReach} />}
      <ImageStyled src={imgSrc} />
      <button
        onClick={handleClickPrev}
        style={{
          position: 'absolute',
          left: 0,
          top: '40%',
          transform: 'translate(0, -40%)',
          padding: '16px',
          zIndex: 9999,
        }}>
        <LeftArrowIcon
          style={{ zIndex: 9999 }}
          width={24}
          height={24}
          color="rgba(255,255,255,0.3)"
        />
      </button>
      <button
        onClick={handleClickNext}
        style={{
          position: 'absolute',
          right: 0,
          top: '40%',
          transform: 'translate(0, -40%)',
          padding: '16px',
          zIndex: 9999,
        }}>
        <RightArrowIcon width={24} height={24} />
      </button>
      {isActive && (
        <Button
          onClick={() => onApply(imgSrc)}
          buttonStyle={!selected ? 'primary' : undefined}
          style={{
            marginTop: '32px',
          }}
          fullscreen
          title={selected ? 'Selected' : 'Apply'}
        />
      )}
    </TreeItemWrapper>
  );
};

const NeedToReach = ({ needToReach }: { needToReach: string }) => {
  return (
    <HorizontalView
      style={{
        position: 'absolute',

        zIndex: 100,
        background: 'rgba(0,0,0,0.5)',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}>
      <HorizontalView style={{ gap: '5px' }}>
        <LockIcon width={17} height={17} color="#B4BBC3" />{' '}
        <HorizontalView style={{ gap: '3px' }}>
          <p style={{ fontSize: '12px', fontWeight: '600' }}>
            Reach <CoinIcon width={10} height={10} /> {needToReach}
          </p>
        </HorizontalView>
      </HorizontalView>
    </HorizontalView>
  );
};
